import React from 'react';
import { WithOptionalPermission, WithOptionalPermissionProps } from '../WithPermission';
import { NavItem as CommonNavItem, NavItemProps as CommonNavItemProps } from '@td-client-frontend/common';

export type NavItemProps = WithOptionalPermissionProps & CommonNavItemProps;
export const NavItem = ({ requiredPerms, mode, ...navItemProps }: NavItemProps) => (
  <WithOptionalPermission requiredPerms={requiredPerms} mode={mode}>
    <CommonNavItem {...navItemProps} />
  </WithOptionalPermission>
);
